import React, {Component} from "react";
import localization from "../../../config/localization";
import {Formik} from "formik";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../../components/Letflow/Snackbar/GlobalSnackbar";
import FormContent from "./FormView";
import {request} from "../../../api-client";


class FormController extends Component {
  state = {
    submitted: false,
    id: '',
    name: '',
  };

  componentDidMount = () => {
    if (!this.props.create) {
      request.section.get(this.props.sectionId)
        .then(section => this.setState({
          id: section.id,
          name: section.name,
        }))
        .then(() => this.setState({loaded: true}))
    }
    else {
      this.setState({loaded: true})
    }
  }

  validate = values => {
    const errors = {};

    if (!values.name) {
      errors.name = localization.get("validator.is_required");
    }

    return errors;
  };

  initialValues = () => ({
    name: this.state.name,
    handleCloseForm: (resetForm) => this.handleCloseForm(resetForm),
  });

  submitRequest = (data) => {
    if (this.props.create) {
      return request.section.create(data)
    } else {
      return request.section.update(data)
    }
  }

  handleCloseForm = (resetForm) => {
    this.props.exitForm()
    resetForm({})
  }

  render = () => {
    if (this.state.loaded) {
      return (
        <Formik
          initialValues={this.initialValues()}
          validate={this.validate}
          onSubmit={(values, actions) => {
            actions.setSubmitting(true);
            const data = {
              ...values,
              id: this.props.sectionId,
            }

            this.submitRequest(data)
              .then(() => GlobalSnackbar.showGenericSuccess())
              .then(() => this.handleCloseForm(actions.resetForm))
              .then(() => this.setState({ submitted: true }))
              .catch((res) => GlobalSnackbar.showGenericError())
              .finally(() => actions.setSubmitting(false));
          }}
        >
          {formikProps => (
            FormContent(formikProps)
          )}
        </Formik>
      );
    } else {
      return <div style={{height: 300}}></div>
    }

  };
}

export default FormController;
